module.exports = __webpack_public_path__ + "static/media/embed-button-en.3fae765f.jpg";